import React from 'react';
import { IconBtn } from '../IconBtn/IconBtn.jsx';
import { useFocusTrap } from '../../hooks.js';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

function useWidthMode() {
  const get = () => (window.innerWidth >= 1280 ? 'full' : window.innerWidth >= 960 ? 'collapsed' : 'drawer');
  const [m, setM] = React.useState(get);
  React.useEffect(() => { const f = () => setM(get()); window.addEventListener('resize', f); return () => window.removeEventListener('resize', f); }, []);
  return m;
}

/**
 * Responsive frame: ≥1280 full rail, 960–1279 collapsed, <960 drawer.
 *
 * @param {object} p
 * @param {React.ReactElement} [p.rail]
 * @param {React.ReactNode} [p.topbar]
 * @param {React.ReactNode} [p.children]
 * @param {'full'|'collapsed'|'drawer'} [p.mode]
 */
export function AppShell({ rail, topbar, children, mode }) {
  const auto = useWidthMode(); const m = mode || auto;
  const [drawer, setDrawer] = React.useState(false);
  const panel = React.useRef(null);
  useFocusTrap(panel, m === 'drawer' && drawer);
  React.useEffect(() => { if (!drawer) return; const k = (e) => e.key === 'Escape' && setDrawer(false); window.addEventListener('keydown', k); return () => window.removeEventListener('keydown', k); }, [drawer]);
  const railEl = rail ? React.cloneElement(rail, { collapsed: m === 'collapsed', onNavigate: (...a) => { setDrawer(false); rail.props.onNavigate && rail.props.onNavigate(...a); } }) : null;
  return h('div', { style: { display: 'flex', minHeight: '100vh', background: 'var(--bg)', color: 'var(--tx)', fontFamily: BODY } },
    m !== 'drawer' ? railEl : null,
    m === 'drawer' && drawer ? h(React.Fragment, null, h('div', { className: 'gx-fade', onClick: () => setDrawer(false), style: { position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 60 } }), h('div', { ref: panel, className: 'gx-drawer', role: 'dialog', 'aria-modal': true, 'aria-label': 'Navigation', style: { position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 61, display: 'flex', overflowY: 'auto' } }, railEl)) : null,
    h('div', { style: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' } },
      h('div', { style: { position: 'relative', display: 'flex', alignItems: 'center', minHeight: 46, borderBottom: ink(2), background: 'var(--bg)' } },
        m === 'drawer' ? h('span', { style: { paddingLeft: 12 } }, h(IconBtn, { icon: 'panel-right', label: 'Open navigation', onClick: () => setDrawer(true), style: { transform: 'scaleX(-1)' } })) : null,
        h('div', { style: { flex: 1, minWidth: 0 } }, topbar)),
      h('main', { style: { flex: 1, padding: 'var(--page-y) var(--page-x) 48px', minWidth: 0 } }, children)));
}
